import { FastField, Field } from "formik";
import * as React from "react";

export const FieldWrapper: React.FC<{
  children: React.ReactNode;
  name: string;
  fast: boolean;
}> = ({ children, name, fast }) => {
  if (fast) return <FastField name={name}>{children}</FastField>;

  return <Field name={name}>{children}</Field>;
};
